import script from "./AuthenticationView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticationView.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticationView.vue?vue&type=style&index=0&id=99ee966c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99ee966c"]])

export default __exports__